import { render } from "./ContentDropdowns.vue?vue&type=template&id=0677dab7"
import script from "./ContentDropdowns.vue?vue&type=script&lang=js"
export * from "./ContentDropdowns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__